import React from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import { UserAccess, PanelAccess } from '@sounditi/ft2-api';
import { Helmet } from 'react-helmet'
import { withTranslation } from 'react-i18next';

import { setSession } from '../reducers/user';
import { showNotification } from '../reducers/notifications';
import { setRedirect } from '../reducers/navigation';

import T from '../components/Translate';
import Link from '../components/Link';
import Input from '../components/Input';

import { getURLParameter } from '../utils/global';

import { URL_CAMPAIGNS, URL_SIGNUP, URL_WIZARD_FILE } from '../config/urls';

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth.api,
  tokenData: state.user.tokenData,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setSession: val => dispatch(setSession(val)),
  showNotification: val => dispatch(showNotification(val)),
  setRedirect: val => dispatch(setRedirect(val)),
  dispatch,
})

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataValidated: false,
      password: "",
      email: "",
      showPassword: false,
      loading: false,
      emailValidated: false,
    };
  }

  componentDidMount() {
    const { showNotification } = this.props;

    if (getURLParameter("emailvalidation") === "true") {
      setTimeout(() => showNotification("emailValidated"), 500);

      if (getURLParameter("email")) {
        this.setState({ email: getURLParameter("email"), emailValidated: true }, () =>
          this.refs.email.refresh()
        );
      }
    }

    this.sendEvent("control_enter_screen_login", "Login")
  }

  async sendEvent(action, screen) {
    const panelAccess = new PanelAccess();

    try {
      const createdAt = new Date().getTime();
      const sessionId = localStorage.getItem('sessionID-info');
      const browser = localStorage.getItem('browser-info');
      const device = localStorage.getItem('device-info');
      // type, device, browser, screen, sessionId, createdAt
      await panelAccess.postAction(action, screen, device, browser, sessionId, createdAt);
      // console.log({ postAction: { type: action, screen, device, browser, sessionId, createdAt } });

    } catch(error) {
      // console.log(error);
    };
  }

  async onLoginClick() {
    const { setRedirect, setSession, showNotification, auth, dispatch } = this.props;
    const { dataValidated, email, password } = this.state;

    const userAccess = new UserAccess();

    if (dataValidated) {
      try {
        this.setState({ loading: true });
        const hydratedLogin = await userAccess.hydratedLogin(email, password, auth);
        hydratedLogin.user = await userAccess.getUserData();

        dispatch(setSession(hydratedLogin)).then(() => {
          const userID = hydratedLogin.user.id || undefined;
          const name = hydratedLogin.user.data.name || hydratedLogin.user.name || "";
          const email = hydratedLogin.user.data.email || hydratedLogin.user.email || "";

          if (userID) {
            window.Froged('set', {
              userId: userID,
              name,
              email
            });
          }
          window.Froged("track", "on_login");
          this.goCampaigns();
        })
      } catch (error) {
        this.setState({ loading: false });

        if (error.message === "Password dont match" || error.message === "User not found") {
          showNotification("invalidLoginData");
          this.refs.email.setInvalid();
          this.refs.password.setInvalid();
        } else if (error.message === "Email not verified") {
          showNotification("emailNotVerified");
        } else {
          showNotification("genericError");
        }
      }
    } else {
      if (!email) {
        this.refs.email.setInvalid();
      }

      if (!password) {
        this.refs.password.setInvalid();
      }

      showNotification("invalidData");
    }
  }

  validateData() {
    const { password, email } = this.state;
    const dataValidated = (password !== '' && email !== '');
    this.setState({ dataValidated });
  }

  onInputChange(val) {
    this.setState(val, () => {
      this.validateData();
    });
  }

  onCheckboxChange(val) {
    this.setState({ [val.target.name]: val.target.checked });
  }

  goCampaigns() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGNS });
  }

  goSignup() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_SIGNUP });
  }

  goWizardFile() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_WIZARD_FILE });
  }

  render() {
    const { loading, email, password, emailValidated } = this.state;
    const { t } = this.props;

    if (loading) {
      return (
        <div className="loading-cover">
          <div className="cover"></div>
          <div>
            <Spinner speed={0.8} color="#00C7E7" size={20} />
          </div>
        </div>
      );
    }

    return (
      <div className="app screen-login">
        <Helmet>
          <title>{t('Login_Browser_Title')}</title>
        </Helmet>
        <div className="login-box">
          <div className="logo-wrapper">
            <img className="logo" src="../assets/img/main-logo-c.png" alt="Company logo" />
          </div>
          <div className="login-wrapper">
            <Input
              placeholder={t('Login_Email_Placeholder')}
              name="email"
              label={t('Login_Email')}
              value={email}
              ref="email"
              type="text"
              onChange={val => this.onInputChange(val)}
              onPressEnter={e => this.onLoginClick(e)}
            />
            {!emailValidated && (
              <Input
                last
                placeholder={t('Login_Password_Placeholder')}
                name="password" 
                label={t('Login_Password')}
                value={password}
                ref="password"
                type="password"
                onChange={val => this.onInputChange(val)}
                onPressEnter={e => this.onLoginClick(e)}
              />
            )}
            {emailValidated && (
              <Input
                autoFocus
                last
                placeholder={t('Login_Password_Placeholder')}
                name="password" 
                label={t('Login_Password')}
                value={password}
                ref="password"
                type="password"
                onChange={val => this.onInputChange(val)}
                onPressEnter={e => this.onLoginClick(e)}
              />
            )}
            {/*
            <div className="check-remember">
              <div className="check-wrapper">
                <label className="check">
                  <input onChange={val => this.onCheckboxChange(val)} name="keepLogin" type="checkbox" value={keepLogin} />
                  <span className="checkmark"></span>
                </label>
              </div>
              <p>Keep me signed in</p>
            </div>
            */}
            <Link secondary className="full-width" onClick={e => this.onLoginClick(e)}><T text="Login_Log_In_Button" /></Link>
            <Link secondary inline className="full-width" to="/send-new-password"><T text="Login_Forgotten_Password" /></Link>
            {/* <Link main to="/remember-password">Forgot your password?</Link> */}
            {!emailValidated && (
              <div className="register-box">
                <h2><T text="Login_Dont_Have_Account" /></h2>
                {/* <Link main className="full-width" onClick={() => this.goWizardFile()}>
                  <T text="Login_Create_Test_Button" />
                </Link> */}
                <Link secondary className="full-width" onClick={() => this.goSignup()}><T text="Login_Register_Button" /></Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Login);
